<mat-form-field class="w100">
  <input
    matInput
    [min]="min()"
    [max]="max()"
    [placeholder]="placeholder()"
    (keydown)="onlyNumbers($event)"
    [(ngModel)]="value"
    [disabled]="disabled()"
    (keydown.enter)="submit.emit()"
    (focus)="onFocus($event)"
    (wheel)="$any($event.target).blur()"
  />
</mat-form-field>

@if (hint()) {
  <mat-hint>{{ hint() }}</mat-hint>
} @else {
  <mat-hint></mat-hint>
}

@if (hideSubscript()) {
  <ng-container [ngTemplateOutlet]="errorContent"></ng-container>
} @else {
  <div class="flex-row w100 input-subscript">
    <ng-container [ngTemplateOutlet]="errorContent"></ng-container>
  </div>
}

<ng-template #errorContent>
  <ng-content></ng-content>
</ng-template>
